import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InputTextModule} from "../../../../../core/component/input-text/input-text.module";
import {SmsContentInputComponent} from "./sms-content-input.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
    ],
    declarations: [
        SmsContentInputComponent,
    ],
    exports: [
        SmsContentInputComponent
    ],
})
export class SmsContentInputModule {
}